import { render, staticRenderFns } from "./password.vue?vue&type=template&id=2256adae&scoped=true&"
import script from "./password.vue?vue&type=script&lang=js&"
export * from "./password.vue?vue&type=script&lang=js&"
import style0 from "./password.vue?vue&type=style&index=0&id=2256adae&prod&lang=scss&"
import style1 from "./password.vue?vue&type=style&index=1&id=2256adae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2256adae",
  null
  
)

export default component.exports